<mat-card>
  <div class="summary-headline">
    <span>Paketübersicht</span>
    @if (bundleItems().length > 3) {
      <ui-icon-button buttonStyle="unthemed" (clicked)="listExpanded.set(!listExpanded())" [icon]="listExpanded() ? 'chevron-up' : 'chevron-down'"></ui-icon-button>
    }
  </div>

  <hr class="summary-headline-separator">

  <ui-configurable-bundle-form-bundle-item-list
    [class.expandable]="bundleItems().length > 3"
    [class.expanded]="listExpanded()"
    [bundleTemplate]="bundleTemplate()"
    [bundleItems]="bundleItems()"
    [canSeePrices]="customer()?.customerUserPermissions?.canSeePrices ?? false"
    [bundleState]="bundleState()"
    (bundleStateChange)="bundleState.set($event)"
  >
  </ui-configurable-bundle-form-bundle-item-list>

  @if (customer()?.customerUserPermissions?.canSeePrices) {
    <div class="container">
      <div class="label highlighted-text">Zwischensumme (netto)</div>
      <div class="value highlighted-text">
        <ui-product-prices-formatter
          [price]="summaryState().net">
        </ui-product-prices-formatter>
      </div>

      @if (summaryState().taxes.length) {
        @for (tax of summaryState().taxes; track tax.taxRate) {
          <div class="label">Mehrwertsteuer ({{ tax.taxRate }}%)</div>
          <div class="value">
            <ui-product-prices-formatter
              [price]="tax.amount">
            </ui-product-prices-formatter>
          </div>
        }

        <div class="label">Mehrwertsteuer (Gesamt)</div>
        <div class="value">
          <ui-product-prices-formatter
            [price]="summaryState().tax">
          </ui-product-prices-formatter>
        </div>
      }

      <div class="label highlighted-text sum">Summe (brutto)</div>
      <div class="value total">
        <ui-product-prices-formatter
          [price]="summaryState().gross">
        </ui-product-prices-formatter>
      </div>
    </div>

    <hr>
  }

  <div class="wrapper-labels">
    <ui-product-bundle-valid-to-label
      [showDot]="true"
      [validFrom]="bundleTemplate().validFrom"
      [validTo]="bundleTemplate().validTo">
    </ui-product-bundle-valid-to-label>

    <ui-product-bundle-max-order-count-label
      [showDot]="true"
      [showIcon]="false"
      [maxOrderCount]="bundleTemplate().productMaxOrderAmount">
    </ui-product-bundle-max-order-count-label>
  </div>

  @if (!isInCart()) {
    <ui-button class="fill-width" [disabled]="addToCartDisabled() || isAddToCartLoading()" [loading]="isAddToCartLoading()" (clicked)="addToCart.emit()">In den Warenkorb</ui-button>
  } @else {
    <ui-button class="fill-width" buttonStyle="tonal" [disabled]="addToCartDisabled() || isAddToCartLoading()" [loading]="isAddToCartLoading()" (clicked)="addToCart.emit()">Paketaktion anpassen</ui-button>
  }
</mat-card>
